import Switch from "components/Switch";
import { observer } from 'mobx-react-lite';
import { TSubscriptions } from 'stores/UserStore';
import { stringFromDate } from 'utils/common';
import { ASSET_PREFIX } from 'utils/constants';

interface ISnoozeSwitchSection {
  subscription: TSubscriptions[number];
  snoozeSwitchEnabled: boolean;
  handleToggleToResume: () => void;
  handleToggleToSnooze: () => void;
  validSnoozeDurationsForSubscription: {
    durations: number[];
    unit: string;
  } | null;
}
export const SnoozeSubscriptionRegular = observer(
  ({
    subscription,
    handleToggleToResume,
    handleToggleToSnooze,
  }: ISnoozeSwitchSection) => {
    if (!subscription) {
      return null;
    }

    return (
      <div className="w-full p-[1em] ">
        <div className="bg-[#F6F6F6] p-6 rounded-xl flex gap-4">
          <div className="w-full flex justify-between items-center">
            <div className="flex gap-4">
              <div className="flex items-center">
                <img
                  src={`${ASSET_PREFIX}/images/account/subscriptions/snooze-no-glow.svg`}
                  style={{ height: '20px' }}
                />
              </div>
              <div>
                <div className="font-extrabold text-[15px]">
                  {subscription.subscription.status === 'SNOOZED'
                    ? 'Subscription Snoozed'
                    : 'Snooze subscription'}
                </div>

                <div className="font-semibold text-[10px]">
                  {subscription.subscription.status === 'SNOOZED'
                    ? subscription.subscription.snoozedUntil
                      ? `Resumes on ${stringFromDate(subscription.subscription.snoozedUntil)}`
                      : null
                    : 'No payment for up to 4 weeks'}
                </div>
              </div>
            </div>
            <div>
              <Switch
                glowColor={'#50E3C2'}
                design3
                enabled={subscription.subscription.status === 'SNOOZED'}
                onToggle={
                  subscription.subscription.status === 'SNOOZED'
                    ? handleToggleToResume
                    : handleToggleToSnooze
                }
                id={undefined}
                disabled={undefined}
                withoutFill={undefined}
                optionalSliderImage={undefined}
                customOnOffLabels={undefined}
                style={undefined}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
);